export default "__VITE_ASSET__3ei3$gk_tR5H6RNSALn3SQ__"